import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  OnDestroy,
  AfterViewInit,
} from '@angular/core';
import { SipService } from '../services/sip.service';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DtmfDialogComponent } from '../dtmf-dialog/dtmf-dialog.component';
import { EveCall } from '../models/eve-call';

@Component({
  selector: 'app-dialpad',
  templateUrl: './dialpad.component.html',
  styleUrls: ['./dialpad.component.css'],
})
export class DialpadComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('remoteAudio') remoteAudio!: ElementRef<HTMLAudioElement>;

  phoneNumber: string = '';
  error: string = '';
  incomingCall: string = '';

  digits = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];

  private remoteStreamSubscription?: Subscription;

  private activeCallsSubscription?: Subscription;
  private incomingCallsSubscription?: Subscription;
  private selectedCallSubscription?: Subscription;

  // Active calls from SIP service (calls with session state not Terminated)
  activeCalls: EveCall[] = [];
  incomingCalls: EveCall[] = [];


  public selectedCall: EveCall | null = null;
  constructor(private sipService: SipService, private dialog: MatDialog) {}

  ngOnInit() {
    // ✅ Subscribe to SIP.js updates
    this.sipService.errorMessage.subscribe((msg) => (this.error = msg));

    this.remoteStreamSubscription = this.sipService.remoteStream$.subscribe(
      (stream) => {
        if (stream) {
          this.attachAudioStream(stream);
        }
      }
    );


    // Subscribe to active calls from SIP service
    this.activeCallsSubscription = this.sipService.activeCalls$.subscribe(
      (calls) => {
        this.activeCalls = calls;
      }
    );

    // Subscribe to incoming calls observable.
    this.incomingCallsSubscription = this.sipService.incomingCalls$.subscribe(
      (calls) => {
        this.incomingCalls = calls;
      }
    );

    this.selectedCallSubscription = this.sipService.selectedCall$.subscribe((call) => {
      this.selectedCall = call;
      
    });
  }

  ngAfterViewInit() {
    console.log(
      '🎧 Remote audio element initialized:',
      this.remoteAudio.nativeElement
    );
    if (this.remoteAudio?.nativeElement) {
      this.sipService.setAudioElement(this.remoteAudio.nativeElement); // ✅ Pass to sipService
    }
  }

  // ✅ Bind the remote audio stream to the audio element
  attachAudioStream(stream: MediaStream) {
    if (this.remoteAudio && this.remoteAudio.nativeElement) {
      this.remoteAudio.nativeElement.srcObject = stream;
    }
  }

  async makeCall() {
    if (this.error || !this.phoneNumber) {
      console.error('Cannot make call due to errors or empty number');
      return;
    }
    // Initiate outgoing call via SIP service (it will add the call to the active calls list)
    this.sipService.makeCall(this.phoneNumber);
    // Clear dialpad input after initiating the call
    this.phoneNumber = '';
  }
  // Call control methods per active call
  async acceptCall(call: EveCall) {
    await this.sipService.acceptCall(call);
  }

  async rejectCall(call: EveCall) {
    await this.sipService.rejectCall(call);
  }

  async toggleHold(call: EveCall) {
    if (call.isOnHold) {
      await call.unholdCall();
    } else {
      await call.holdCall();
    }
  }

  async endCall(call: EveCall) {
    await this.sipService.endCall(call);
  }

  openDtmfDialog(call: EveCall) {
    this.dialog.open(DtmfDialogComponent, {
      width: '250px',
      data: { call: call }
    });
  }

  addDigit(digit: string) {
    this.phoneNumber += digit;
  }

  deleteDigit() {
    if (this.phoneNumber.length > 0) {
      this.phoneNumber = this.phoneNumber.slice(0, -1);
    }
  }

  async startRecording() {
    this.sipService.startRecording();
  }

  stopRecording() {
    this.sipService.stopRecording();
  }

  playRecording() {
    this.sipService.playRecording();
  }

  


  selectThisCall(call: EveCall) {
    this.sipService.selectCall(call);
    this.selectedCall = call; // ✅ Update selected call
  }


  clearInput() {
    this.phoneNumber = ''; 
  }


  get hasCalls(): boolean {
  return this.activeCalls.length > 0 || this.incomingCalls.length > 0;
}

  ngOnDestroy() {
    this.incomingCallsSubscription?.unsubscribe();
    this.activeCallsSubscription?.unsubscribe();
    this.remoteStreamSubscription?.unsubscribe(); // ✅ Prevent memory leaks

    this.selectedCallSubscription?.unsubscribe(); // ✅ Prevent memory leaks
  }
}
